// Category overrides for meta_list properties
// 格式：{ ComponentName: { propertyKey: 'CorrectCategory' } }
// 沒有 override 的 property 會沿用 meta_list 原始 category。
// 目前為空，待透過 Category Viewer 檢視後再填入。

export const categoryOverrides = {};
